<div (click)="openTrashDialog($event)">
  <mat-icon svgIcon="iconTrashCanOutline"></mat-icon>
  <ng-content></ng-content>
</div>
<ng-template #deleteRef>
  <ng-container *ngIf="title && description; else default">
    <app-dialog id="delete-forever" [title]="title" (save)="onClick()" [confirmation]="title" mat-dialog-close>
      <div mat-dialog-content id="delete-package-content">
        <p class="pb-2">
          {{ description }}
        </p>
      </div>
    </app-dialog>
  </ng-container>
  <ng-template #default>
    <app-dialog
      id="delete-forever"
      [title]="'deleteRoleForever.heading' | translate"
      (save)="onClick()"
      [confirmation]="'button.deleteForever' | translate"
      mat-dialog-close
    >
      <div mat-dialog-content id="delete-package-content">
        <p class="pb-2">
          {{ 'deleteRoleForever.content.warning' | translate }}
        </p>
      </div>
    </app-dialog>
  </ng-template>
</ng-template>
